// Integration categories
export const INTEGRATION_CATEGORIES = [
  'PMS',
  'Access Control',
  'Package Management',
  'Thermostat',
  'Resident Engagement',
  'Other',
]

// Integration statuses
export const INTEGRATION_STATUSES = {
  AVAILABLE: 'Available',
  PENDING: 'Pending',
  NO_API: 'Does not offer API',
}

// Integrations data from the provided document
// `description`/`features`/`howItWorks` are translated via `t()`; `id`/`name`/`category`/
// `status`/`website`/`logo` stay raw (identity/display values matched elsewhere by `===`).
export const getIntegrationsData = (t) => [
  // PMS Integrations
  {
    id: 'entrata',
    name: 'Entrata',
    description: t('integrations:data.entrata.description'),
    category: 'PMS',
    status: INTEGRATION_STATUSES.AVAILABLE,
    website: 'www.entrata.com',
    logo: '/images/integrations/entrata.png',
    features: t('integrations:data.entrata.features', { returnObjects: true }),
    howItWorks: t('integrations:data.entrata.howItWorks'),
  },
  {
    id: 'yardi-voyager',
    name: 'Yardi Voyager',
    description: t('integrations:data.yardi-voyager.description'),
    category: 'PMS',
    status: INTEGRATION_STATUSES.AVAILABLE,
    website: 'www.yardi.com',
    logo: '/images/integrations/yardi.png',
    features: t('integrations:data.yardi-voyager.features', { returnObjects: true }),
    howItWorks: t('integrations:data.yardi-voyager.howItWorks'),
  },
  {
    id: 'realpage-onesite',
    name: 'RealPage OneSite',
    description: t('integrations:data.realpage-onesite.description'),
    category: 'PMS',
    status: INTEGRATION_STATUSES.AVAILABLE,
    website: 'www.realpage.com',
    logo: '/images/integrations/realpage.png',
    features: t('integrations:data.realpage-onesite.features', { returnObjects: true }),
    howItWorks: t('integrations:data.realpage-onesite.howItWorks'),
  },
  {
    id: 'mri-software',
    name: 'MRI Software',
    description: t('integrations:data.mri-software.description'),
    category: 'PMS',
    status: INTEGRATION_STATUSES.PENDING,
    website: 'www.mrisoftware.com',
    logo: '/images/integrations/mri.png',
    features: t('integrations:data.mri-software.features', { returnObjects: true }),
    howItWorks: t('integrations:data.mri-software.howItWorks'),
  },
  {
    id: 'resman',
    name: 'ResMan',
    description: t('integrations:data.resman.description'),
    category: 'PMS',
    status: INTEGRATION_STATUSES.AVAILABLE,
    website: 'www.resman.com',
    logo: '/images/integrations/resman.png',
    features: t('integrations:data.resman.features', { returnObjects: true }),
    howItWorks: t('integrations:data.resman.howItWorks'),
  },
  {
    id: 'rent-manager',
    name: 'Rent Manager',
    description: t('integrations:data.rent-manager.description'),
    category: 'PMS',
    status: INTEGRATION_STATUSES.AVAILABLE,
    website: 'www.rentmanager.com',
    logo: '/images/integrations/rentmanager.png',
    features: t('integrations:data.rent-manager.features', { returnObjects: true }),
    howItWorks: t('integrations:data.rent-manager.howItWorks'),
  },

  // Access Control Integrations
  {
    id: 'butterflymx',
    name: 'ButterflyMX',
    description: t('integrations:data.butterflymx.description'),
    category: 'Access Control',
    status: INTEGRATION_STATUSES.AVAILABLE,
    website: 'www.butterflymx.com',
    logo: '/images/integrations/bmx.png',
    features: t('integrations:data.butterflymx.features', { returnObjects: true }),
    howItWorks: t('integrations:data.butterflymx.howItWorks'),
  },
  {
    id: 'dormakaba-evo',
    name: 'Dormakaba – EVO',
    description: t('integrations:data.dormakaba-evo.description'),
    category: 'Access Control',
    status: INTEGRATION_STATUSES.AVAILABLE,
    website: 'www.dormakaba.com',
    logo: '/images/integrations/dormakaba.png',
    features: t('integrations:data.dormakaba-evo.features', { returnObjects: true }),
    howItWorks: t('integrations:data.dormakaba-evo.howItWorks'),
  },
  {
    id: 'dormakaba-saffire',
    name: 'Dormakaba – Saffire',
    description: t('integrations:data.dormakaba-saffire.description'),
    category: 'Access Control',
    status: INTEGRATION_STATUSES.AVAILABLE,
    website: 'www.dormakaba.com',
    logo: '/images/integrations/dormakaba.png',
    features: t('integrations:data.dormakaba-saffire.features', { returnObjects: true }),
    howItWorks: t('integrations:data.dormakaba-saffire.howItWorks'),
  },
  {
    id: 'salto-ks',
    name: 'SALTO – KS',
    description: t('integrations:data.salto-ks.description'),
    category: 'Access Control',
    status: INTEGRATION_STATUSES.AVAILABLE,
    website: 'www.saltosystems.com',
    logo: '/images/integrations/saltoks.png',
    features: t('integrations:data.salto-ks.features', { returnObjects: true }),
    howItWorks: t('integrations:data.salto-ks.howItWorks'),
  },
  {
    id: 'salto-space',
    name: 'SALTO – Space',
    description: t('integrations:data.salto-space.description'),
    category: 'Access Control',
    status: INTEGRATION_STATUSES.AVAILABLE,
    website: 'www.saltosystems.com',
    logo: '/images/integrations/saltospace.png',
    features: t('integrations:data.salto-space.features', { returnObjects: true }),
    howItWorks: t('integrations:data.salto-space.howItWorks'),
  },
  {
    id: 'schlage-engage',
    name: 'Schlage Engage',
    description: t('integrations:data.schlage-engage.description'),
    category: 'Access Control',
    status: INTEGRATION_STATUSES.AVAILABLE,
    website: 'www.schlage.com',
    logo: '/images/integrations/allegionengage.png',
    features: t('integrations:data.schlage-engage.features', { returnObjects: true }),
    howItWorks: t('integrations:data.schlage-engage.howItWorks'),
  },
  {
    id: 'yale-assure',
    name: 'Yale – Assure BLE',
    description: t('integrations:data.yale-assure.description'),
    category: 'Access Control',
    status: INTEGRATION_STATUSES.AVAILABLE,
    website: 'www.yalehome.com',
    logo: '/images/integrations/yale.png',
    features: t('integrations:data.yale-assure.features', { returnObjects: true }),
    howItWorks: t('integrations:data.yale-assure.howItWorks'),
  },
  {
    id: 'latch',
    name: 'Latch',
    description: t('integrations:data.latch.description'),
    category: 'Access Control',
    status: INTEGRATION_STATUSES.AVAILABLE,
    website: 'www.latch.com',
    logo: '/images/integrations/latch.png',
    features: t('integrations:data.latch.features', { returnObjects: true }),
    howItWorks: t('integrations:data.latch.howItWorks'),
  },
  {
    id: 'brivo-onair',
    name: 'Brivo On-Air',
    description: t('integrations:data.brivo-onair.description'),
    category: 'Access Control',
    status: INTEGRATION_STATUSES.AVAILABLE,
    website: 'www.brivo.com',
    logo: '/images/integrations/brivo.png',
    features: t('integrations:data.brivo-onair.features', { returnObjects: true }),
    howItWorks: t('integrations:data.brivo-onair.howItWorks'),
  },
  {
    id: 'openpath',
    name: 'Openpath',
    description: t('integrations:data.openpath.description'),
    category: 'Access Control',
    status: INTEGRATION_STATUSES.AVAILABLE,
    website: 'www.openpath.com',
    logo: '/images/integrations/openpath.png',
    features: t('integrations:data.openpath.features', { returnObjects: true }),
    howItWorks: t('integrations:data.openpath.howItWorks'),
  },
  {
    id: 'assa-abloy-accentra',
    name: 'ASSA ABLOY Accentra',
    description: t('integrations:data.assa-abloy-accentra.description'),
    category: 'Access Control',
    status: INTEGRATION_STATUSES.AVAILABLE,
    website: 'www.assaabloy.com',
    logo: '/images/integrations/assaabloy.png',
    features: t('integrations:data.assa-abloy-accentra.features', { returnObjects: true }),
    howItWorks: t('integrations:data.assa-abloy-accentra.howItWorks'),
  },
  {
    id: 'assa-abloy-visionline',
    name: 'ASSA ABLOY Visionline',
    description: t('integrations:data.assa-abloy-visionline.description'),
    category: 'Access Control',
    status: INTEGRATION_STATUSES.AVAILABLE,
    website: 'www.assaabloyglobalsolutions.com',
    logo: '/images/integrations/visionline.png',
    features: t('integrations:data.assa-abloy-visionline.features', { returnObjects: true }),
    howItWorks: t('integrations:data.assa-abloy-visionline.howItWorks'),
  },
  {
    id: 'otis-destination',
    name: 'Otis Dispatch',
    description: t('integrations:data.otis-destination.description'),
    category: 'Access Control',
    status: INTEGRATION_STATUSES.AVAILABLE,
    website: 'www.otis.com',
    logo: '/images/integrations/otis.png',
    features: t('integrations:data.otis-destination.features', { returnObjects: true }),
    howItWorks: t('integrations:data.otis-destination.howItWorks'),
  },
  {
    id: 'comelit',
    name: 'Comelit',
    description: t('integrations:data.comelit.description'),
    category: 'Access Control',
    status: INTEGRATION_STATUSES.AVAILABLE,
    website: 'www.comelitgroup.com',
    logo: '/images/integrations/comelit.png',
    features: t('integrations:data.comelit.features', { returnObjects: true }),
    howItWorks: t('integrations:data.comelit.howItWorks'),
  },
  {
    id: '2n',
    name: '2N',
    description: t('integrations:data.2n.description'),
    category: 'Access Control',
    status: INTEGRATION_STATUSES.AVAILABLE,
    website: 'www.2n.com',
    logo: '/images/integrations/2n.png',
    features: t('integrations:data.2n.features', { returnObjects: true }),
    howItWorks: t('integrations:data.2n.howItWorks'),
  },
  {
    id: 'swiftlane',
    name: 'Swiftlane',
    description: t('integrations:data.swiftlane.description'),
    category: 'Access Control',
    status: INTEGRATION_STATUSES.AVAILABLE,
    website: 'www.swiftlane.com',
    logo: '/images/integrations/swiftlane.png',
    features: t('integrations:data.swiftlane.features', { returnObjects: true }),
    howItWorks: t('integrations:data.swiftlane.howItWorks'),
  },
  {
    id: 'rently',
    name: 'Rently',
    description: t('integrations:data.rently.description'),
    category: 'Access Control',
    status: INTEGRATION_STATUSES.AVAILABLE,
    website: 'www.rently.com',
    logo: '/images/integrations/rently.png',
    features: t('integrations:data.rently.features', { returnObjects: true }),
    howItWorks: t('integrations:data.rently.howItWorks'),
  },
  {
    id: 'hid',
    name: 'HID',
    description: t('integrations:data.hid.description'),
    category: 'Access Control',
    status: INTEGRATION_STATUSES.AVAILABLE,
    website: 'www.hidglobal.com',
    logo: '/images/integrations/hid.png',
    features: t('integrations:data.hid.features', { returnObjects: true }),
    howItWorks: t('integrations:data.hid.howItWorks'),
  },

  // Package Management Integrations
  {
    id: 'luxer-one',
    name: 'Luxer One',
    description: t('integrations:data.luxer-one.description'),
    category: 'Package Management',
    status: INTEGRATION_STATUSES.AVAILABLE,
    website: 'www.luxerone.com',
    logo: '/images/integrations/luxerone.png',
    features: t('integrations:data.luxer-one.features', { returnObjects: true }),
    howItWorks: t('integrations:data.luxer-one.howItWorks'),
  },
  {
    id: 'parcel-pending',
    name: 'Parcel Pending ',
    description: t('integrations:data.parcel-pending.description'),
    category: 'Package Management',
    status: INTEGRATION_STATUSES.AVAILABLE,
    website: 'www.parcelpending.com',
    logo: '/images/integrations/parcelpending.png',
    features: t('integrations:data.parcel-pending.features', { returnObjects: true }),
    howItWorks: t('integrations:data.parcel-pending.howItWorks'),
  },
  {
    id: 'hello-package',
    name: 'HelloPackage',
    description: t('integrations:data.hello-package.description'),
    category: 'Package Management',
    status: INTEGRATION_STATUSES.AVAILABLE,
    website: 'www.hellopackage.com',
    logo: '/images/integrations/hellopackage.png',
    features: t('integrations:data.hello-package.features', { returnObjects: true }),
    howItWorks: t('integrations:data.hello-package.howItWorks'),
  },

  // Thermostat Integrations
  {
    id: 'honeywell-resideo',
    name: 'Honeywell Thermostats',
    description: t('integrations:data.honeywell-resideo.description'),
    category: 'Thermostat',
    status: INTEGRATION_STATUSES.PENDING,
    website: 'www.resideo.com',
    logo: '/images/integrations/honeywell.png',
    features: t('integrations:data.honeywell-resideo.features', { returnObjects: true }),
    howItWorks: t('integrations:data.honeywell-resideo.howItWorks'),
  },
  {
    id: 'google-nest',
    name: 'Google Nest Thermostat',
    description: t('integrations:data.google-nest.description'),
    category: 'Thermostat',
    status: INTEGRATION_STATUSES.AVAILABLE,
    website: 'www.google.com/nest',
    logo: '/images/integrations/nest.png',
    features: t('integrations:data.google-nest.features', { returnObjects: true }),
    howItWorks: t('integrations:data.google-nest.howItWorks'),
  },
  {
    id: 'ecobee',
    name: 'ecobee Thermostat',
    description: t('integrations:data.ecobee.description'),
    category: 'Thermostat',
    status: INTEGRATION_STATUSES.AVAILABLE,
    website: 'www.ecobee.com',
    logo: '/images/integrations/ecobee.png',
    features: t('integrations:data.ecobee.features', { returnObjects: true }),
    howItWorks: t('integrations:data.ecobee.howItWorks'),
  },
  {
    id: 'daikin',
    name: 'Daikin Thermostat',
    description: t('integrations:data.daikin.description'),
    category: 'Thermostat',
    status: INTEGRATION_STATUSES.AVAILABLE,
    website: 'www.daikin.com',
    logo: '/images/integrations/daikin.png',
    features: t('integrations:data.daikin.features', { returnObjects: true }),
    howItWorks: t('integrations:data.daikin.howItWorks'),
  },
  // Other Integrations
  {
    id: 'breathe-ev',
    name: 'BreatheEV',
    description: t('integrations:data.breathe-ev.description'),
    category: 'Other',
    status: INTEGRATION_STATUSES.AVAILABLE,
    website: 'www.breatheev.com',
    logo: '/images/integrations/breatheev.png',
    features: t('integrations:data.breathe-ev.features', { returnObjects: true }),
    howItWorks: t('integrations:data.breathe-ev.howItWorks'),
  },

  {
    id: 'wellness',
    name: 'Wellness',
    description: t('integrations:data.wellness.description'),
    category: 'Resident Engagement',
    status: INTEGRATION_STATUSES.AVAILABLE,
    logo: '/images/integrations/wellness.png',
    features: t('integrations:data.wellness.features', { returnObjects: true }),
    howItWorks: t('integrations:data.wellness.howItWorks'),
  },
]

// Display labels only — `value` stays a fixed English string used to match
// against `integration.status`/`category` in INTEGRATIONS_DATA (untranslated).
export const getIntegrationStatusOptions = (t) => [
  { id: 0, value: 'All', text: t('integrations:shared.allOption') },
  { id: 1, value: 'Available', text: t('integrations:statuses.available') },
  { id: 2, value: 'Pending', text: t('integrations:statuses.pending') },
  { id: 3, value: 'Does not offer API', text: t('integrations:statuses.doesNotOfferApi') },
]

export const getCategoryLabels = (t) => ({
  PMS: t('integrations:categories.pms'),
  'Access Control': t('integrations:categories.accessControl'),
  'Package Management': t('integrations:categories.packageManagement'),
  Thermostat: t('integrations:categories.thermostat'),
  'Resident Engagement': t('integrations:categories.residentEngagement'),
  Other: t('integrations:categories.other'),
})
